<template>
  <div
    class="ag-info-box"
  >
    <div class="ag-info-box__body">
      <div class="ag-info-box__icon">
        <ag-icon
          modifier="info-box"
          name="question"
        />
      </div>
      <div class="ag-info-box__cta">
        <div class="ag-info-box__cta-backdrop"></div>
        <div class="ag-info-box__cta-text">
          Sprechen Sie uns an
        </div>
      </div>
      <p class="ag-info-box__text">
        Tel:
        <a class="ag-info-box__link" href="tel:+492218201270">0221 / 820 12 70</a>
      </p>
      <p class="ag-info-box__text">
        Mail:
        <a class="ag-info-box__link" :href="`mailto:${getMail}`">
          {{ getMail }}
        </a>
      </p>

    </div>
  </div>
</template>

<script>
import AgIcon from '@/components/shared/AgIcon.vue';

export default {
  name: 'AgInfoBox',
  components: {
    AgIcon,
  },
  props: {
    isMarketing: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    getMail() {
      if (this.isMarketing) {
        return 'redaktion@advogarant.de';
      }
      return 'kunden@advogarant.de';
    },
  },
};
</script>

<style lang="scss">

.ag-info-box {
  font-size: rem(14px);
  padding: rem(10px);
  margin-top: rem(30px);
  margin-bottom: rem(20px);
  font-weight: 600;
  width: 100%;
  background-color: $bg-dark-color;

  &__body {
    padding: rem(25px) rem(15px);
    border: 3px solid $html-bg-color;
    position: relative;

    @include mq($mq-large) {
      padding: rem(20px);
    }
  }

  &__icon {
    position: absolute;
    top: rem(-35px);
    left: 50%;
    transform: translate(-50%, 0);
    background-color: #ECEFFA;
    padding: rem(10px);
    border-radius: rem(50px);

    @include mq($mq-large) {
      transform: none;
      position: static;
      display: inline-block;
      padding: 0;
      margin-right: rem(10px);
    }
  }

  &__cta {
    position: relative;
    display: inline-block;
    width: 100%;
    height: rem(20px);
    margin-bottom: rem(10px);

    @include mq($mq-large) {
      width: rem(200px);
      height: rem(10px);
    }
  }

  &__cta-text {
    position: absolute;
    width: rem(200px);
    font-size: rem(18px);
    font-family: $display-font;
    font-weight: 700;
    color: $primary-color;
    font-style: italic;
    margin-left: rem(8px);
  }

  &__cta-backdrop {
    position: absolute;
    height: rem(16px);
    width: rem(185px);
    background-color: #BCDAFF;
    top: rem(10px);
  }

  &__text {
    font-weight: 400;
    margin: rem(10px) 0;
  }

  &__link {
    font-weight: 600;
  }
}
</style>
